import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { LOGISTICS_VEHICLE_READ } from '~/components/routes/logistics/tabs'
import {
  LogisticsRecordRoute,
  logisticsRecordIdParam,
} from '~/components/routes/logistics/logistics-record-page'
import { VehiclePage } from '~/components/routes/logistics/vehicle-page'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsSearchSchema } from '../-search-schema'

export const Route = createFileRoute('/_authenticated/logistics/vehicles/$vehicleId')({
  staticData: {
    permission: LOGISTICS_VEHICLE_READ,
  },
  component: VehicleDetailRoute,
  params: {
    parse: z.object({ vehicleId: logisticsRecordIdParam() }).parse,
  },
  // Mêmes paramètres que la page Logistique : les filtres de la liste suivent l'aller-retour.
  validateSearch: logisticsSearchSchema,
})
withRoutePermissions(Route)

function VehicleDetailRoute() {
  const { vehicleId } = Route.useParams()
  return (
    <LogisticsRecordRoute
      tab="vehicles"
      search={Route.useSearch()}
      permission={LOGISTICS_VEHICLE_READ}
    >
      {(search) => <VehiclePage vehicleId={vehicleId} search={search} />}
    </LogisticsRecordRoute>
  )
}
